
export const NONUSER_CHARGE_STATUS_UNPAID = 0;
export const NONUSER_CHARGE_STATUS_SUCCESS = 1;
export const NONUSER_CHARGE_STATUS_FAILED = 2;
export const NONUSER_CHARGE_STATUS_REVOKED = 4;

export const NONUSER_CHARGE_EXPENSE_TYPE_LOSS = 0;
export const NONUSER_CHARGE_EXPENSE_TYPE_REPAIR = 1;
export const NONUSER_CHARGE_EXPENSE_TYPE_GROUP = [
    NONUSER_CHARGE_EXPENSE_TYPE_LOSS,
    NONUSER_CHARGE_EXPENSE_TYPE_REPAIR,
];

export const REVOKE_NONUSER_CHARGE_WHITELIST = [
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_FAILED
];

export const NONUSER_ERROR_TITLE_OUT_OF_RANGE = 201;
export const NONUSER_ERROR_AMOUNT_OUT_OF_RANGE = 203;
